import SendTestModal, { SendTestModalProps } from './SendTestModal';

export type { SendTestModalProps };
export default SendTestModal;
